import { Component, OnInit, forwardRef } from "@angular/core";
import { NavController, NavParams, ModalController } from "@ionic/angular";
import { EnquetePerguntasPage } from "../enquete-perguntas/enquete-perguntas.page";
import { EnqueteProvider } from "src/app/services/enquete/enquete";
import { IonicModule } from "@ionic/angular";

import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ImagePipe } from "src/app/pipes/image/image";
import { TranslateModule } from "@ngx-translate/core";
import { NomenclaturaPipe } from "src/app/pipes/nomenclatura/nomenclatura";

@Component({
  selector: "app-enquete-iniciar",
  templateUrl: "./enquete-iniciar.page.html",
  styleUrls: ["./enquete-iniciar.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, ImagePipe, TranslateModule, NomenclaturaPipe],
})
export class EnqueteIniciarPage implements OnInit {
  idEnquete: string;
  enquete: any = {};
  disableBotao = false;
  descricao: string;
  perguntasLength: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public enqueteProvider: EnqueteProvider
  ) {
    this.idEnquete = this.navParams.get("idEnquete");
    this.descricao = this.navParams.get("descricao");

    this.enqueteProvider.getEnquete(this.idEnquete).subscribe((data) => {
      this.enquete = data;
      this.perguntasLength = data.perguntas;
    });
  }

  ngOnInit() {}

  async iniciarEnquete() {
    this.disableBotao = true;
    this.enqueteProvider.iniciarEnquete(this.idEnquete).subscribe(async (result) => {
      let data = { idEnquete: this.idEnquete, descricao: this.descricao, perguntasLength: this.perguntasLength };
      await this.modalCtrl.dismiss({ iniciar: true, data: data});
      return;
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
